import classNames from 'classnames/bind';
import commaNumber from 'comma-number';
import React, { useState, useMemo } from 'react';

import styles from './index.module.scss';

import AccordionCaret from '@/components/ui/AccordionCaret';
import { Cell } from '@/components/ui/dashboard/Monitor';
import { getDistanceAlongPath } from '@/utils/MapUtils';

const cx = classNames.bind(styles);

const Summary = ({ data: commands }) => {
  const [isExpanded, setExpanded] = useState(true);

  // 총 거리
  const totalDistance = useMemo(() => {
    const path = [];
    commands.forEach((command) => {
      switch (command.type) {
        case 'navLand':
        case 'navLoiterTime':
        case 'navLoiterToAlt':
        case 'navLoiterTurns':
        case 'navTakeoff':
        case 'navWaypoint':
          path.push(command.data.position);
          break;

        case 'navReturnToLaunch':
          path.push(commands[0].data.position);
          break;

        default:
          break;
      }
    });

    return getDistanceAlongPath(path);
  }, [commands]);

  const toggleShow = () => {
    setExpanded(!isExpanded);
  };

  return (
    <div className={cx('container')}>
      <div className={cx('header')} onClick={toggleShow}>
        <div className={cx('title')}>Summary</div>
        <AccordionCaret up={isExpanded} size={16} />
      </div>
      <div className={cx(['body', { expanded: isExpanded }])}>
        <div className={cx('inner')}>
          <Cell data={[{ title: 'Count', value: commaNumber(commands.length ?? 0) }]} />
          <Cell data={[{ title: 'Distance', value: commaNumber((totalDistance / 1000).toFixed(1)), unit: 'km' }]} />
        </div>
      </div>
    </div>
  );
};

export default Summary;
